import React, { useState } from 'react';
import './SidebarMenu.css';

const SidebarMenu = ({ isOpen, onClose, onLogout, userData }) => {
    // Suppressed activeTab state as the menu is now a single view

    if (!isOpen) return null;

    // Calcul du pourcentage de crédits (Hypothèse: 20 crédits par mois pour le plan gratuit/standard)
    const maxCredits = 20; // À ajuster ou récupérer du backend si variable
    const currentCredits = userData?.credits || 0;
    const creditPercentage = Math.min(100, Math.max(0, (currentCredits / maxCredits) * 100));

    // Determine specific subscription label if needed, or just use usage_type
    const subscriptionLabel = userData?.usage_type ? userData.usage_type.charAt(0).toUpperCase() + userData.usage_type.slice(1) : 'Start';

    return (
        <div className="sidebar-overlay" onClick={onClose}>
            <div className="sidebar-container" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={onClose}>&times;</button>

                <div className="sidebar-header">
                    <h2>MENU</h2>
                </div>

                <div className="sidebar-content">
                    {/* SECTION PROFIL UNIQUE */}
                    <div className="menu-item no-hover" style={{ cursor: 'default' }}>
                        <span>PROFIL</span>
                    </div>

                    <div className="submenu-content slide-in" style={{ display: 'block', borderLeft: 'none', paddingLeft: 0 }}>

                        {/* 1. PSEUDO */}
                        <div className="info-row">
                            <span className="label">Pseudo :</span>
                            <span className="value">
                                {userData?.username || 'Utilisateur'}
                            </span>
                        </div>

                        {/* 2. TYPE D'ABONNEMENT */}
                        <div className="info-row">
                            <span className="label">Abonnement :</span>
                            <span className="value">{subscriptionLabel}</span>
                        </div>

                        {/* 3. CRÉDITS DISPONIBLES (Moved here) */}
                        <div className="credits-section" style={{ marginTop: '20px' }}>
                            <div className="credits-header">
                                <span>Crédit disponible</span>
                                <span>{currentCredits} / {maxCredits}</span>
                            </div>
                            <div className="progress-bar-bg">
                                <div
                                    className="progress-bar-fill"
                                    style={{ width: `${creditPercentage}%` }}
                                ></div>
                            </div>
                            <p className="credits-info">Renouvellement le 1er du mois</p>
                        </div>

                    </div>
                </div>

                <div className="sidebar-footer">
                    <button className="logout-btn-sidebar" onClick={onLogout}>
                        DÉCONNEXION
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SidebarMenu;
